import { NgModule } from '@angular/core';

import { QrcodeComponent } from './qrcode.component';

@NgModule({
  declarations: [QrcodeComponent],
  exports: [QrcodeComponent]
})
export class NgxQRCodeModule {
}
